import type { ComponentProps } from "react";
import { ProductGridItem } from "@hatch-digital-nl/bravilor-storybook";
import { SimpleProduct } from "../interfaces/SimpleProduct";

export type StorybookSimpleProduct = ComponentProps<
    typeof ProductGridItem
>["product"];

export const asStorybookProduct = (
    product: SimpleProduct,
): StorybookSimpleProduct => product as StorybookSimpleProduct;
